import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type DeployNowIdentityProviderChangeRequestModalProps = {
    identityProviderName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
};

export const DeployNowIdentityProviderChangeRequestModal = (props: DeployNowIdentityProviderChangeRequestModalProps) => {
    const { identityProviderName, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>immediately deploy</b> the Change Request for the Identity Provider
                    named <b>{identityProviderName}</b>.</p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.SUBMIT}
            title={"Deploy Identity Provider Change Request"}
            body={bodyElement}
            buttonText={"Deploy Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};